import axios from "axios";
import API from "./api";
const examService = {
  getEaxmList(UserID, GroupId, yiban_id, user_token) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${
            API.localhost
          }/v1/exam/getExamListResource?group_id=${GroupId.toString()}&user_id=${UserID.toString()}&user_token=${user_token}&yiban_id=${yiban_id}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  submitExam(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API.localhost}/v1/exam/StartExamResource`, {
          orderId
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
export { examService };
